import { Routes } from '@angular/router';
import { CustomPageComponent } from './custom-page/custom-page.component';
var ɵ0 = { permissions: ['pages.view'], willSetSeo: true };
var routes = [
    {
        path: 'pages/:id/:slug',
        component: CustomPageComponent,
        data: ɵ0
    }
];
var PagesRoutingModule = /** @class */ (function () {
    function PagesRoutingModule() {
    }
    return PagesRoutingModule;
}());
export { PagesRoutingModule };
var PagesModule = /** @class */ (function () {
    function PagesModule() {
    }
    return PagesModule;
}());
export { PagesModule };
export { ɵ0 };
